const yesNoSufferTradingLosses = {
    yes: { point: [3] },
    no: { point: [0] },
};

export default yesNoSufferTradingLosses;
